import type { SubstrateSearchSuggestionsResponseMessageSuggestion } from "../../data/schema/SubstrateSearchSuggestionsResponse";

export default function validateSubstrateMessageSuggestions(suggestions: SubstrateSearchSuggestionsResponseMessageSuggestion[]): boolean {
    return suggestions.every(suggestion => suggestion.Subject !== undefined &&
        Boolean(suggestion.ItemId?.Id && suggestion.ReferenceId));
}
